import { TD_MIXPANEL_PROJECT_TOKEN } from "~/data/consts";
import { MixpanelAnalyticsPlatform } from "./analytics_platforms/mixpanel_analytics_platform";
import { IAnalyticsService } from "./IAnalyticsService";
import { config } from "~/data/config";

class TataDigitalAnalyticsService implements IAnalyticsService {
  defaultProperties?: Record<string, any>;
  mixpanelAnalyticsPlatform?: IAnalyticsPlatform;
  initialised = false;

  initialise = () => {
    if (!this.initialised) {
      this.mixpanelAnalyticsPlatform = new MixpanelAnalyticsPlatform(
        TD_MIXPANEL_PROJECT_TOKEN
      );
      this.initialised = true;
    }
  };

  static _instance: TataDigitalAnalyticsService | null = null;

  static getInstance(props: {
    defaultProperties?: Record<string, any>;
  }): TataDigitalAnalyticsService {
    if (!this._instance) {
      this._instance = new TataDigitalAnalyticsService(props);
    }
    return this._instance;
  }

  constructor(props: { defaultProperties?: Record<string, any> }) {
    this.defaultProperties = props.defaultProperties;
  }

  logEvent(event: string, properties?: Record<string, any>): void {
    try {
      this.initialise();
      if (config.env == "Prod") {
        this.mixpanelAnalyticsPlatform?.trackEvent(event, {
          ...this.defaultProperties,
          ...properties,
        });
      }
    } catch (error) {
      console.error("Error logging event", error);
    }
  }

  setIdentity(identity: string): void {
    this.initialise();
    this.mixpanelAnalyticsPlatform?.setIdentity(identity);
  }

  logout(): void {
    this.initialise();
    this.mixpanelAnalyticsPlatform?.logout();
  }
}

export default TataDigitalAnalyticsService;
